export enum MapConnection {
  None = "NONE",
  PointOfInterest = "POI",
  AreaOfInterest = "AOI",
}
